// VERSION 4.0.0
import RetAdobeLaunch from './RetAdobeLaunch';

const adobeLaunch = new RetAdobeLaunch();

// Expose on window for IIFE consumers
declare global {
  interface Window {
    dataLayer: object[];
    adobeLaunch: RetAdobeLaunch;
  }
}
window.dataLayer = window.dataLayer || [];
window.adobeLaunch = window.adobeLaunch || adobeLaunch;

export default adobeLaunch;
